export const questionTypes = {
  checkboxes: 'checkboxes',
  emojiRating: 'emojiRating',
  rating: 'rating',
  text: 'text',
  yearSelect: 'yearSelect',
}

export const forms = {
  student: {
    book: {
      title: 'Skicka meddelande',
      contentType: 'book',
      questions: [
        {
          question: 'Jag går i årskurs',
          name: 'year',
          type: questionTypes.yearSelect,
        },
        {
          question: 'Vad tycker du om texten?',
          name: 'rating',
          type: questionTypes.rating,
          minLabel: 'Lätt att förstå',
          maxLabel: 'Mycket svår att förstå',
        },
        {
          question: 'Tycker du att du lärde dig något av övningarna?',
          name: 'learned',
          type: questionTypes.rating,
          minLabel: 'Ingenting alls',
          maxLabel: 'Väldigt mycket',
        },
        {
          question: 'Tycker du att övningarna var lätta eller svåra?',
          name: 'difficulty',
          type: questionTypes.rating,
          minLabel: 'Väldigt lätta',
          maxLabel: 'Väldigt svåra',
        },
        {
          question: 'Har du några förslag till oss, för att göra boken bättre?',
          name: 'suggestions',
          type: questionTypes.text,
        },
      ],
    },
    section: {
      title: 'Skicka meddelande',
      contentType: 'section',
      questions: [
        {
          question: 'Jag går i årskurs',
          name: 'year',
          type: questionTypes.yearSelect,
        },
        {
          question: 'Vad tycker du om avsnittet?',
          name: 'rating',
          type: questionTypes.emojiRating,
        },
        {
          question: 'Jag har jobbat med avsnittet:',
          name: 'workType',
          type: questionTypes.checkboxes,
          options: [
            'i skolan',
            'hemma',
            'helt själv',
            'med lite hjälp av en lärare',
            'med mycket hjälp av en lärare',
            'med lite hjälp av en förälder/annan vuxen',
            'med mycket hjälp av en förälder/annan vuxen',
            'tillsammans med en eller några i klassen',
            'tillsammans med läraren och hela klassen',
          ],
        },
        {
          question: 'Detta gillade jag mest:',
          name: 'mostLiked',
          type: questionTypes.text,
        },
        {
          question: 'Detta gillade jag minst:',
          name: 'leastLiked',
          type: questionTypes.text,
        },
        {
          question: 'Jag har ett önskemål:',
          name: 'wish',
          type: questionTypes.text,
        },
        {
          question: 'Jag har hittat ett fel:',
          name: 'error',
          type: questionTypes.text,
        },
      ],
    },
    // section: {
    //   title: 'Skicka meddelande',
    //   contentType: 'section',
    //   questions: [
    //     {
    //       question: 'Jag går i årskurs',
    //       name: 'year',
    //       type: questionTypes.yearSelect,
    //     },
    //     {
    //       question: 'Vad tycker du om texten?',
    //       name: 'rating',
    //       type: questionTypes.rating,
    //       minLabel: 'Lätt att förstå',
    //       maxLabel: 'Mycket svårt att förstå',
    //     },
    //     {
    //       question: 'Tycker du att du lärde dig något av övningarna?',
    //       name: 'learned',
    //       type: questionTypes.rating,
    //       minLabel: 'Ingenting alls',
    //       maxLabel: 'Väldigt mycket',
    //     },
    //     {
    //       question: 'Tycker du att övningarna var lätta eller svåra?',
    //       name: 'difficulty',
    //       type: questionTypes.rating,
    //       minLabel: 'Väldigt lätta',
    //       maxLabel: 'Väldigt svåra',
    //     },
    //     {
    //       question: 'Har du några förslag till oss, för att göra avsnittet bättre?',
    //       name: 'suggestions',
    //       type: questionTypes.text,
    //     },
    //   ],
    // },
  },
  teacher: {
    book: {
      title: 'Skicka meddelande',
      contentType: 'book',
      questions: [
        {
          question: 'Hur användbar är boken för dig/dina elever?',
          name: 'rating',
          type: questionTypes.rating,
          minLabel: 'Inte alls användbar',
          maxLabel: 'Mycket användbar',
        },
        {
          question: 'Vad gillar du med boken?',
          name: 'likes',
          type: questionTypes.text,
        },
        {
          question: 'Har du några förslag till oss, för att göra boken bättre?',
          name: 'suggestions',
          type: questionTypes.text,
        },
      ],
    },
    section: {
      title: 'Skicka meddelande',
      contentType: 'section',
      questions: [
        {
          question: 'Hur användbart är avsnittet för dig/dina elever?',
          name: 'rating',
          type: questionTypes.rating,
          minLabel: 'Inte alls användbart',
          maxLabel: 'Mycket användbart',
        },
        {
          question: 'Vad gillar du med avsnittet?',
          name: 'likes',
          type: questionTypes.text,
        },
        {
          question:
            'Har du några förslag till oss, för att göra avsnittet bättre?',
          name: 'suggestions',
          type: questionTypes.text,
        },
      ],
    },
  },
}
